import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6aa3d4c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "course-list" }
const _hoisted_3 = { class: "item-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "card-footer" }

import { inject, ref, watchEffect } from 'vue'
import { getCourse, getImages } from '@/api/common'
import { useRouter } from 'vue-router'
import { ERR_SUCCESS } from '@/api/config'
import { CourseConfig } from '@/types'
import Pagination from '@/components/common/Pagination.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Course',
  props: { ceci: { required: true } },
  setup(__props) {

const router = useRouter()
const dataList = ref<CourseConfig[]>([])
const currentPage = ref<number>(1)
const currentCourseId = ref(0)
const pageSize = ref<number>(12)
const totalSize = ref<number>(0)
const thumbsImage = ref('')
const dialogVisible = ref(false)
const dialogModelWidth = ref(380)
const dialogModelTitle = ref('图片预览')
const { searchKeyword } = inject('searchKeyword', { searchKeyword: ref('') })

// eslint-disable-next-line no-undef
const props = __props

async function fetchData () {
  currentCourseId.value = 0
  if (!props.ceci) {
    dataList.value = []
    return
  }
  try {
    const {
      code,
      result: {
        items: data,
        total
      }
    } = await getCourse({
      params: {
        page: currentPage.value,
        pageSize: pageSize.value,
        title: searchKeyword.value,
        ceci: props.ceci
      }
    })
    if (code === ERR_SUCCESS && data) {
      dataList.value = data
      totalSize.value = total
      currentCourseId.value = data[0]?.id || 0
    }
  } catch (error) {
    console.error('Error fetching data:', error)
  }
}

const goToDetail = (id: number) => {
  router.push({
    name: 'ResourceList',
    params: { id }
  })
}

const openOriginal = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer')
}

const resolveUrl = (url: string) => {
  router.push({
    path: '/resolve',
    query: { url }
  })
}

const thumbnails = (title: string, thumbs: any, width: number) => {
  if (thumbs === null) {
    thumbsImage.value = ''
  } else {
    thumbsImage.value = getImages(thumbs, width)
    dialogVisible.value = true
    dialogModelWidth.value = width
    dialogModelTitle.value = title + '_width=' + width + 'px'
  }
}

watchEffect(() => fetchData())


return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_el_empty, {
          "image-size": 300,
          description: "暂无数据"
        })
      ], 512), [
        [_vShow, dataList.value.length==0]
      ]),
      _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
        title: dialogModelTitle.value,
        width: dialogModelWidth.value,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (dialogVisible.value = false))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_image, {
            src: thumbsImage.value,
            fit: "contain",
            style: {"width":"100%","height":"100%"}
          }, null, 8, ["src"])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "width"]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, ({id, original_link, teachers, thumbnails:thumbs, title}, index) => {
          return (_openBlock(), _createBlock(_component_el_card, {
            key: index,
            class: _normalizeClass({ 'active-card': currentCourseId.value === id })
          }, {
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    thumbs
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          size: "small",
                          onClick: ($event: any) => (openOriginal(thumbs))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查看原图")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    original_link
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          size: "small",
                          onClick: ($event: any) => (openOriginal(original_link))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("官网链接")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    original_link
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 2,
                          size: "small",
                          onClick: ($event: any) => (resolveUrl(original_link))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("解析资源")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                onClick: ($event: any) => (goToDetail(id))
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_text, {
                    "line-clamp": "2",
                    truncated: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(title), 1)
                    ]),
                    _: 2
                  }, 1024),
                  teachers
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        type: "success"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(teachers), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_divider),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_image, { src: thumbs }, null, 8, ["src"])
                ])
              ], 8, _hoisted_4)
            ]),
            _: 2
          }, 1032, ["class"]))
        }), 128))
      ]),
      (totalSize.value>pageSize.value)
        ? (_openBlock(), _createBlock(Pagination, {
            key: 0,
            "current-page": currentPage.value,
            "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((currentPage).value = $event)),
            "page-size": pageSize.value,
            "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageSize).value = $event)),
            "total-size": totalSize.value
          }, null, 8, ["current-page", "page-size", "total-size"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})